import React, { useMemo } from 'react';

import HeroCard from '../cards/product/hero';
import LargeCard from '../cards/product/large';
import MiniCard from '../cards/product/mini';
import ComparativeCard from '../cards/product/comparative';
import PriceCard from '../cards/product/price-list';
import { useLinkComponent } from '../../utils/component';
import { AffiliateLink } from '../../atoms/link';

interface ClubicContainerProps {
  cell: any;
  SlateContent: React.FC<{ data: object }>;
  eventCta?: (shopName?: string, price?: string, position?: string, itemId?: number) => void;
}

export function ProductCardArticle({ cell, eventCta, SlateContent }: ClubicContainerProps) {
  const NavLink = useLinkComponent();

  const template = cell?.content?.state?.template;
  const { imageId, title, conclusionJson, conclusion, urlCta, urlTest, urlProduct, prices, extensionImg } =
    cell?.content?.state?.data ?? {};

  const mainCtaInfos = useMemo(
    () => cell?.content?.state?.data?.mainCtaInfos ?? {},
    [cell?.content?.state?.data?.mainCtaInfos],
  );

  mainCtaInfos.ctaPropsCard = useMemo(() => {
    if (mainCtaInfos?.link) {
      return {
        href: mainCtaInfos.link,
        openInNewWindow: !mainCtaInfos.internalLink,
        rel: mainCtaInfos.internalLink ? null : ['nofollow'],
        onClick: () => eventCta(),
      };
    }

    return null;
  }, [mainCtaInfos, eventCta]);

  const props = useMemo(
    () => ({
      withDataSheet: cell.content.state.data.withDataSheet,
      ...cell.content.state.data,
      image: {
        imageId,
        alt: title,
        title,
        extension: extensionImg,
      },
      ctaLink: {
        href: urlCta ?? urlProduct,
        as: AffiliateLink,
      },
      testLink: {
        href: urlTest,
        as: NavLink,
      },
      productLink: {
        href: urlProduct,
        as: NavLink,
      },
      conclusion: conclusionJson ? <SlateContent data={conclusionJson} /> : conclusion,
      mainCtaInfos,
      prices,
    }),
    [
      cell.content.state.data,
      imageId,
      title,
      extensionImg,
      urlCta,
      urlProduct,
      urlTest,
      NavLink,
      conclusionJson,
      SlateContent,
      conclusion,
      mainCtaInfos,
      prices,
    ],
  );

  switch (template) {
    case 'hero':
      return <HeroCard size={cell.size} {...props} eventCta={eventCta} />;
    case 'mini':
      return <MiniCard size={cell.size} {...props} />;
    case 'comparo':
      return <ComparativeCard size={cell.size} {...props} eventCta={eventCta} />;
    case 'price':
      return <PriceCard size={cell.size} {...props} eventCta={eventCta} />;
    default:
      if (
        props.mainCtaInfos?.layout === 'product' &&
        !props.mainCtaInfos?.label &&
        !props?.pros?.length &&
        !props?.conclusion
      ) {
        return null;
      }

      return <LargeCard size={cell.size} {...props} />;
  }
}

export default ProductCardArticle;
